import { render, staticRenderFns } from "./TopMenu.vue?vue&type=template&id=56f3d758&"
import script from "./TopMenu.vue?vue&type=script&lang=js&"
export * from "./TopMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56f3d758')) {
      api.createRecord('56f3d758', component.options)
    } else {
      api.reload('56f3d758', component.options)
    }
    module.hot.accept("./TopMenu.vue?vue&type=template&id=56f3d758&", function () {
      api.rerender('56f3d758', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/TopMenu.vue"
export default component.exports